import { render } from "./ServiceData.vue?vue&type=template&id=382b2860&scoped=true"
import script from "./ServiceData.vue?vue&type=script&lang=js"
export * from "./ServiceData.vue?vue&type=script&lang=js"

import "./ServiceData.vue?vue&type=style&index=0&id=382b2860&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382b2860"]])

export default __exports__